import { CheckBadge } from './check-badge'
import { type LabeledOption } from './enum-labels'

export function NoneSelectedRow({
  option,
  onClear
}: {
  option: LabeledOption
  onClear: () => void
}) {
  return (
    <div className='flex flex-col gap-2 rounded-xl border border-accent bg-accent-light px-4 py-3 sm:flex-row sm:items-center sm:gap-3'>
      <div className='flex min-w-0 flex-1 items-center gap-3'>
        <CheckBadge />
        <div className='min-w-0'>
          <p className='text-[14px] font-medium text-ink'>{option.label}</p>
          <p className='mt-0.5 text-[12px] text-ink-soft'>
            {option.description}
          </p>
        </div>
      </div>
      <button
        type='button'
        onClick={onClear}
        className='min-h-11 shrink-0 cursor-pointer rounded-md px-2 text-[12px] font-medium text-ink-muted transition-colors hover:bg-page hover:text-ink sm:min-h-0 sm:py-1'
      >
        Change
      </button>
    </div>
  )
}
